/* eslint-disable no-nested-ternary */
import React, { useContext } from "react";
import { Image, Grid } from "semantic-ui-react";
import "photoswipe/dist/photoswipe.css";
import { Gallery as PhotoSwipe, Item } from "react-photoswipe-gallery";
import { ThemeContext } from "../store/theme";

import image1 from "../assets/features/screenshot_1.png";
import image2 from "../assets/features/screenshot_2.png";
import image3 from "../assets/features/screenshot_3.png";
import image4 from "../assets/features/screenshot_4.png";
import image5 from "../assets/features/screenshot_5.png";
import image6 from "../assets/features/screenshot_6.png";
import image7 from "../assets/features/screenshot_7.png";
import image1d from "../assets/features/screenshot_1d.png";
import image2d from "../assets/features/screenshot_2d.png";
import image3d from "../assets/features/screenshot_3d.png";
import image4d from "../assets/features/screenshot_4d.png";
import image5d from "../assets/features/screenshot_5d.png";
import image6d from "../assets/features/screenshot_6d.png";
import image7d from "../assets/features/screenshot_7d.png";

const LIGHT_IMAGES = [
  { src: image1, caption: "Screenshot 1" },
  { src: image2, caption: "Screenshot 2" },
  { src: image3, caption: "Screenshot 3" },
  { src: image4, caption: "Screenshot 4" },
  { src: image5, caption: "Screenshot 5" },
  { src: image6, caption: "Screenshot 6" },
  { src: image7, caption: "Screenshot 7" },
];

const DARK_IMAGES = [
  { src: image1d, caption: "Screenshot 1" },
  { src: image2d, caption: "Screenshot 2" },
  { src: image3d, caption: "Screenshot 3" },
  { src: image4d, caption: "Screenshot 4" },
  { src: image5d, caption: "Screenshot 5" },
  { src: image6d, caption: "Screenshot 6" },
  { src: image7d, caption: "Screenshot 7" },
];

const Gallery = ({ noDarkmode }) => {
  const { state } = useContext(ThemeContext);
  const { darkmode } = state;
  const isDarkmode = darkmode && !noDarkmode;
  const DEFAULT_IMAGES = isDarkmode ? DARK_IMAGES : LIGHT_IMAGES;

  return (
    <PhotoSwipe
      options={{
        gallery: "#gallery--fade-transition",
        children: "a",
        showHideAnimationType: "fade",
      }}
      withCaption
    >
      <Grid stackable verticalAlign="middle">
        <Grid.Row columns={DEFAULT_IMAGES.length}>
          {DEFAULT_IMAGES.map((image) => (
            <Grid.Column key={image.src} textAlign="center">
              <Item original={image.src} caption={image.caption}>
                {({ ref, open }) => (
                  <div ref={ref}>
                    <Image
                      style={{ cursor: "pointer" }}
                      src={image.src}
                      onClick={open}
                      bordered
                      rounded
                      centered
                    />
                  </div>
                )}
              </Item>
            </Grid.Column>
          ))}
        </Grid.Row>
      </Grid>
    </PhotoSwipe>
  );
};

/*
              <Image
                as="a"
                href={image.src}
                src={image.src}
                bordered
                rounded
                centered
                onClick={handleOpen(index)}
              />

*/

Gallery.defaultProps = {
  noDarkmode: false,
};

export default Gallery;
